"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupRankExtension = exports.createPagination = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const stargate_1 = require("@cosmjs/stargate");
const query_1 = require("../codec/cyber/rank/v1beta1/query");
function createPagination(page, perPage) {
    return page
        ? {
            page: page,
            perPage: perPage ? perPage : 10,
        }
        : {
            page: 0,
            perPage: 10,
        };
}
exports.createPagination = createPagination;
function setupRankExtension(base) {
    const rpc = (0, stargate_1.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new query_1.QueryClientImpl(rpc);
    return {
        rank: {
            search: async (particle, page, perPage) => {
                const response = await queryService.Search({
                    particle: particle,
                    pagination: createPagination(page, perPage),
                });
                return response;
            },
            backlinks: async (particle, page, perPage) => {
                const response = await queryService.Backlinks({
                    particle: particle,
                    pagination: createPagination(page, perPage),
                });
                return response;
            },
            rank: async (particle) => {
                const response = await queryService.Rank({
                    particle: particle,
                });
                return response;
            },
            karma: async (neuron) => {
                const response = await queryService.Karma({
                    neuron: neuron,
                });
                return response;
            },
            isLinkExist: async (from, to, agent) => {
                const response = await queryService.IsLinkExist({
                    from: from,
                    to: to,
                    address: agent,
                });
                return response;
            },
            isAnyLinkExist: async (from, to) => {
                const response = await queryService.IsAnyLinkExist({
                    from: from,
                    to: to,
                });
                return response;
            },
            negentropy: async () => {
                const response = await queryService.Negentropy({});
                return response;
            },
        },
    };
}
exports.setupRankExtension = setupRankExtension;
//# sourceMappingURL=rank.js.map